import { SUPPORT_EMAIL } from '@/common/utils'

/**
 * contactSupport — Opens the Intercom messenger when available, otherwise
 * falls back to a mailto: link to the support inbox.
 *
 * Designed to be called from Churnkey wall callbacks (no React state), so it
 * accepts the Intercom hook outputs as plain arguments rather than reading
 * them from context.
 *
 * @param {Object} args
 * @param {boolean} args.intercomEnabled - Whether the Intercom feature flag is on.
 * @param {Function} [args.intercomShow] - The `show` function from `useIntercom()`.
 * @returns {void}
 */
export const contactSupport = ({ intercomEnabled, intercomShow }) => {
    if (intercomEnabled && typeof intercomShow === 'function') {
        intercomShow()
        return
    }
    window.open(`mailto:${SUPPORT_EMAIL}`, '_self')
}
